import styled, { css } from 'styled-components';
import { NAVIGATION_ITEMS_MAX_WIDTH } from '../../../../navigation/constants/navigation-items-width';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
import { NAVIGATION_VIEWPORT_BREAKPOINTS } from '../../../constants';
export const navigationItemsContainerStyles = ({ theme, }) => css `
	display: flex;
	flex-direction: column;
	gap: ${pxToRem(theme.spacing['100'])};
	list-style: none;
	margin: 0 auto;
	width: 100%;
	max-width: ${pxToRem(NAVIGATION_ITEMS_MAX_WIDTH)};
	padding: 0;

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.lg)}) {
		gap: 0;
		margin: 0;
		width: unset;
		max-width: unset;
	}
`;
export const NavigationItemsContainer = styled.ul `
	${navigationItemsContainerStyles}
`;
